<template>
  <div id="columnsWrapper">
    <my-title>Kolommen</my-title>

    <create-button
      caption="Nieuwe kolom"
      @click="toggle(true)">
    </create-button>

    <create-button
      caption="Nieuwe categorie"
      @click="toggleCreateCategory(true)">
    </create-button>

    <table class="table is-striped is-fullwidth">
      <thead>
        <tr>
          <th>ID</th>
          <th>Type</th>
          <th>Tabnaam</th>
          <th>Kolomnaam</th>
          <th>Categorie</th>
          <!-- <th>Status</th> -->
          <th></th>
        </tr>
      </thead>

      <!-- TODO: State is being updated from within the component -->
      <tbody>
        <tr v-for="column in columns" :key="column.id">
          <th class="is-narrow">{{ column.id }}</th>

          <template v-if="editing === column">
            <td>
              <div class="select">
                <select v-model="column.type_id">
                  <option
                    v-for="type in types"
                    :key="type.id"
                    :value="type.id">
                    {{ type.name }}
                  </option>
                </select>
              </div>
            </td>

            <td><input class="input" name="tabname" v-model="column.tabname"></td>
            <td><input class="input" name="name" v-model="column.name"></td>
            <td>
              <div class="select">
                <select v-model="column.category_id">
                  <option value=""></option>
                  <option
                    v-for="category in columnCategories"
                    :key="category.id"
                    :value="category.id">
                    {{ category.name }}
                  </option>
                </select>
              </div>
            </td>
            <!-- <td><span class="icon"><i class="fas" :class="column.is_hidden ? 'fa-eye-slash' : 'fa-eye'" @click="toggleVisibility"></i></span></td> -->

            <td class="is-narrow">
              <options-buttons @save="save(column)" @cancel="cancel" :saving="true" :editing="false" :deleting="false"></options-buttons>
            </td>
          </template>

          <template v-else>
            <td>{{ getTypeName(column.type_id) }}</td>
            <td>{{ column.tabname }}</td>
            <td>{{ column.name }}</td>
            <td @click="editCategory(column.category_id)">{{ (column.category_id) ? getCategory(column.category_id).name : '' }}</td>
            <!-- <td><span class="icon"><i class="fas" :class="column.is_hidden ? 'fa-eye-slash' : 'fa-eye'"></i></span></td> -->

            <td class="is-narrow">
              <options-buttons @edit="edit(column)" :deleting="false"></options-buttons>
            </td>
          </template>
        </tr>
      </tbody>
    </table>
    <column :isActive="isActive" @close="toggle(false)"></column>
    <edit-modal
      :isActive="createCategoryIsActive"
      caption="Nieuwe categorie">
      <create-column-category
        :category="editedCategory"
        @close="toggleCreateCategory(false)">
      </create-column-category>
    </edit-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Column from '@/components/columns/Column'
import MyTitle from '@/components/modules/Title'
import EditModal from '@/components/modules/EditModal'
import CreateButton from '@/components/modules/CreateButton'
import OptionsButtons from '@/components/modules/OptionsButtons'
import CreateColumnCategory from '@/components/columns/CreateColumnCategory'

export default {
  components: {
    Column,
    MyTitle,
    EditModal,
    CreateButton,
    OptionsButtons,
    CreateColumnCategory
  },
  data () {
    return {
      editing: null,
      isActive: false,
      editedCategory: null,
      createCategoryIsActive: false
    }
  },
  computed: {
    ...mapGetters({
      types: 'types/types',
      column: 'columns/column',
      columns: 'columns/columns',
      columnCategories: 'columnCategories/columnCategories'
    })
  },
  created () {
    this.$store.dispatch('types/loadAll')
    this.$store.dispatch('columnCategories/loadAll')
  },
  methods: {
    edit (col) {
      this.editing = col
    },
    getCategory (categoryId) {
      return this.columnCategories.find(x => x.id === categoryId)
    },
    editCategory (categoryId) {
      this.editedCategory = this.getCategory(categoryId)

      this.toggleCreateCategory(true)
    },
    cancel () {
      this.editing = null
    },
    save () {
      this.$store.dispatch('columns/save', this.editing)
      this.editing = null
    },
    update () {

    },
    remove () {

    },
    toggle (status) {
      this.isActive = status
    },
    toggleCreateCategory (status) {
      this.createCategoryIsActive = status

      if (!status) {
        this.editedCategory = null
      }
    },
    toggleVisibility () {
      // NOTE: This feature has been disabled. Uncomment in template to enable.
      this.editing.is_hidden = !this.editing.is_hidden
    },
    getTypeName (typeId) {
      return this.types.find(x => x.id === typeId).name
    }
  }
}
</script>
